import { useEffect, useState } from "react"
import { PDFDocument } from "pdf-lib"
import { useForm } from "react-hook-form"
import { sort } from "fast-sort"
import Send from "../../core/communication"
import ReportsScreenDynamicDash from "../../screen/ReportsScreenDynamicDash"
import { customToast } from "../../components/Toast"
import { isValidURL } from "../../core/utils/validateFields"
import { useUploadFile } from "../../core/utils/hooks/uploadItem"
import { useSelector } from "react-redux"
import { getBase64FromUrl } from "../../core/utils/fileUrlToBase64"
import { useScope } from "../SelectProjectCompanyContainer"

const useReportList = () => {
  const [reportList, setReportList] = useState([])
  const [reloadData, setReloadData] = useState(false)
  const { scope, scopeType } = useScope()

  useEffect(() => {
    Send.get(`/report-list/project/${scope?.id}`, `scopeType=${scopeType}`).then((response) => {
      setReportList(response)
    })
  }, [scope?.id, reloadData])

  return [sort(reportList).desc("createdAt"), setReloadData]
}

const ReportsDynamicDashContainer = () => {
  const { projectsByScope } = useScope()
  const user = useSelector((state) => state.app)
  const [reportList, setReloadData] = useReportList()
  const [modalIsOpen, setModalIsOpen] = useState(false)
  const [loading, setLoading] = useState(false)
  const [cardId, setCardId] = useState("")
  const [itemId, setItemId] = useState("")
  const [itemCardId, setItemCardId] = useState("")
  const [newList, setNewList] = useState(false)
  const [newItem, setNewItem] = useState(false)
  const [editList, setEditList] = useState(false)
  const [isList, setIsList] = useState(false)
  const [modalTitle, setModalTitle] = useState("")
  const [title, setTitle] = useState("")
  const [errorImage, setErrorImage] = useState(false)
  const [errorFile, setErrorFile] = useState(false)
  const [errorSave, setErrorSave] = useState("")
  const [isSafeFile, setIsSafeFile] = useState(false)
  const [file, setFile] = useState({})
  const [coverImage, setCoverImage] = useState({})
  const [uploaded, setUploaded] = useState(false)
  const [uploadedImage, setUploadedImage] = useState(false)
  const [processingFile, setProcessingFile] = useState(false)
  const [isRemoveItem, setIsRemoveItem] = useState(false)
  const [selectedProject, setSelectedProject] = useState(null);

  const currentUser = {
    isAdmin: user?.isUserAdmin,
    userId: user?.user?.user?.id,
  }

  const {
    register,
    handleSubmit,
    resetField,
    watch,
    setValue,
    control,
    formState: { errors, isValid },
  } = useForm({
    mode: "onChange",
  })

  const linkFileFieldWatch = watch("linkFile")
  const linkImageFieldWatch = watch("linkCover")

  useEffect(() => {
    if (linkFileFieldWatch?.length && isValidURL(linkFileFieldWatch)) {
      setFile({})
      setUploaded(false)
    }

    if (linkImageFieldWatch?.length && isValidURL(linkImageFieldWatch)) {
      setCoverImage({})
      setUploadedImage(false)
    }
    return
  }, [linkFileFieldWatch, linkImageFieldWatch])

  useEffect(() => {
    if (uploaded || uploadedImage) {
      resetField((uploaded && "linkFile") || "linkCover", { keepError: false })
    }
    return
  }, [uploaded, uploadedImage])

  const reloadData = () => {
    setReloadData((prev) => !prev)
  }

  const onChangeFile = (e, isFileInput = false) => {
    const files = e.target.files
    const fileReader = new FileReader()

    fileReader.fileName = files[0]?.name
    fileReader.readAsDataURL(files[0])

    fileReader.onload = (event) => {
      const fileName = event.target?.fileName || ""
      const newDataFile = { data: event.target.result, type: fileName.split(".").pop() }

      if (isFileInput) {
        setFile(newDataFile)
        setUploaded(true)
      } else {
        setCoverImage(newDataFile)
        setUploadedImage(true)
      }
    }
    e.target.value = null
  }

  const onSaveList = async (title) => {
    if(!selectedProject) {
      customToast('Você deve selecionar um projeto.', 'error');
      return;
    }
    
    setLoading(true)
    try {
      await Send.post("/report-list", {
        name: title,
        project: selectedProject,
        isSafe: isSafeFile,
      })
      closeModal()
      reloadData()
      setLoading(false)
    } catch (error) {
      setErrorSave("Erro ao salvar")
    }
  }

  const onUpdateList = async (title) => {
    if(!selectedProject) {
      customToast('Você deve selecionar um projeto.', 'error');
      return;
    }
    
    setLoading(true)

    try {
      await Send.put(`/report-list/${cardId}`, {
        name: title,
        project: selectedProject,
        isSafe: isSafeFile,
      })
      closeModal()
      reloadData()
      setLoading(false)
    } catch (error) {
      setErrorSave("Erro ao salvar")
    }
  }

  const getSafeListType = (listId) => reportList.filter((list) => list.id === listId)[0]?.isSafe

  const onSaveItem = async (data) => {
    const { title, linkFile, linkCover } = data

    const isSafeType = getSafeListType(cardId)

    let imageUpload = ""
    let fileUpload = file

    if (coverImage?.data) {
      imageUpload = await useUploadFile(coverImage?.data, setErrorImage, coverImage?.type)
    }

    if (!isSafeType) {
      fileUpload = await useUploadFile(file?.data || "", setErrorFile, file?.type)
    }

    setLoading(true)
    setProcessingFile(true)
    setProcessingFile(false)

    try {
      await Send.post("/report-list-item", {
        name: title,
        link:
          linkFile && isSafeType
            ? await getBase64FromUrl(linkFile)
            : linkFile
            ? linkFile
            : fileUpload,
        image: linkCover ? linkCover : imageUpload,
        reportList: cardId,
        // user: currentUser.userId,
        isSafeType,
      })
      closeModal()
      reloadData()
      setLoading(false)
    } catch (error) {
      console.log("err", error)
      setErrorSave("Erro ao salvar")
    }
  }

  const onUpdateItem = async (data) => {
    setLoading(true)
    const isSafeType = getSafeListType(itemCardId)
    const { title, linkFile, linkCover } = data

    const changedFiles = async (current, toCompare, fileUpload) => {
      return current && current.indexOf(toCompare.split(" | ").shift()) !== -1
        ? toCompare
        : await getBase64FromUrl(current)
    }

    const reportListItem = reportList
      .filter((item) => item?.id === itemCardId)[0]
      ?.reportListItem.filter((item) => item?.id === itemId)[0]

    setProcessingFile(true)
    let fileUpload =
      isSafeType && linkFile ? await changedFiles(linkFile, reportListItem.link, file) : file
    let imageUpload = await useUploadFile(coverImage?.data || "", setErrorImage, coverImage?.type)

    if (!isSafeType) {
      fileUpload = await useUploadFile(file?.data || "", setErrorFile, file?.type)
    }
    setProcessingFile(false)

    const body = {
      name: title,
      link: fileUpload,
      image: linkCover ? linkCover : imageUpload,
      reportList: itemCardId,
      // user: currentUser.userId,
      isSafeType,
    }

    imageUpload === reportListItem.image && delete body.image
    fileUpload === reportListItem.link && delete body.link

    try {
      await Send.put(`/report-list-item/${itemId}`, body)
      closeModal()
      reloadData()
      setLoading(false)
    } catch (error) {
      setErrorSave("Erro ao salvar", e)
    }
  }

  const onRemoveItem = async () => {
    try {
      if (cardId === "") {
        await Send.delete(`/report-list-item/${itemId}`)
      } else {
        await Send.delete(`/report-list/${cardId}`)
      }
      closeModal()
      reloadData()
    } catch (e) {
      console.log(e)
    }
  }

  const handleSaveOrUpdate = (data) => {
    if (isList) {
      newList ? onSaveList(data.title) : onUpdateList(data.title)
    } else {
      newItem ? onSaveItem(data) : onUpdateItem(data)
    }
  }

  const openModalCard = (id, name, newItem) => {
    setModalIsOpen(true)

    if (newItem) {
      setCardId(id)
      setModalTitle(name)
      setNewItem(true)
      setValue("title", "")
      setValue("linkCover", "")
      setValue("linkFile", "")
    } else {
      setValue("title", name)
    }
  }

  const openModaEditlItemCard = (reportList, reportListItemId) => {
    setValue("title", reportList.name)
    setItemId(reportList?.id)
    setItemCardId(reportListItemId)
    setModalTitle("Editar Item")
    setValue("linkCover", reportList?.image)

    if (reportList.link.split(" | ").length === 2) {
      setValue("linkFile", `https://${reportList?.link.split(" | ").shift()}.com`)
    } else {
      setValue("linkFile", reportList?.link)
    }

    setModalIsOpen(true)
  }

  const openModalRemoveItem = (itemId, list) => {
    setModalIsOpen(true)
    setIsRemoveItem(true)

    list ? setCardId(itemId) : setItemId(itemId)
    setModalTitle(`Excluir ${list ? "Lista" : "Item"}`)
  }

  const openModalList = (name, id, isSafe = false, project) => {
    if (name && id) {
      setEditList(true)
      setModalTitle("Editar Lista")
      setValue("title", name)
      setIsSafeFile(isSafe)
      setCardId(id)
      setSelectedProject({ value: project?.id, label: project?.description });
    } else {
      setNewList(true)
      setIsSafeFile(false)
      setModalTitle("Nova Lista")
    }

    setIsList(true)
    setModalIsOpen(true)
  }

  const closeModal = () => {
    setCardId("")
    setTitle("")
    setItemCardId("")
    setItemId("")
    setSelectedProject(null);
    setCoverImage({})
    setFile({})
    setUploaded(false)
    setLoading(false)
    setModalIsOpen(false)
    setNewList(false)
    setNewItem(false)
    setIsList(false)
    setEditList(false)
    setIsRemoveItem(false)
    resetField("title", { keepError: false })
    resetField("linkCover", { keepError: false })
    resetField("linkFile", { keepError: false })
  }

  const addingHashPage = async (base64Pdf, hash) => {
    const pdfDoc = await PDFDocument.load(base64Pdf)

    const oldPages = pdfDoc.getPages()
    const { width } = oldPages[0].getSize()

    const newPage = pdfDoc.addPage([width, 750])

    newPage.drawText(`HASH DO ARQUIVO: ${hash}`, { x: 50, y: 700, size: 10 })

    const pdfBytes = await pdfDoc.save()

    return `data:application/pdf;base64,${Buffer.from(pdfBytes).toString("base64")}`
  }

  const openFile = async (fileData, reportlistId) => {
    const isSafeType = getSafeListType(reportlistId)

    if (!isSafeType) {
      return window.open(fileData, "_blank")
    }

    try {
      customToast(`Buscando arquivo, aguarde...`, "info")
      let { nameFile, base64 } = await Send.get(
        `/report-list-item/ipfs/${fileData.split(" | ").shift()}/${fileData.split(" | ").pop()}`,
      )

      if (base64?.message) {
        customToast(`Erro ao localizar arquivo: ${base64?.message}`, "error")
        return
      }

      if (fileData.split(" | ").pop().indexOf("pdf") !== -1) {
        base64 = await addingHashPage(base64, fileData.split(" | ").shift())
      }

      const a = document.createElement("a")
      a.download = `${fileData.split(" | ").shift()}-${nameFile}`
      a.href = base64
      a.click()
    } catch (error) {
      setErrorSave("Erro ao buscar arquivo", error)
    }
  }

  return (
    <ReportsScreenDynamicDash
      {...{
        reportList,
        modalIsOpen,
        closeModal,
        openModalCard,
        openModalList,
        openModaEditlItemCard,
        openModalRemoveItem,
        newList,
        editList,
        modalTitle,
        onChangeFile,
        setTitle,
        title,
        loading,
        errors,
        isValid,
        register,
        watch,
        uploaded,
        uploadedImage,
        processingFile,
        isRemoveItem,
        onRemoveItem,
        currentUser,
        isSafeFile,
        setIsSafeFile,
        openFile,
        projectsByScope,
        selectedProject,
        control,
        setSelectedProject
      }}
      handleSubmit={handleSubmit(handleSaveOrUpdate)}
    />
  )
}

export default ReportsDynamicDashContainer
